<template>
	<div class="homePage">
		<div class="home-header flex flex-a-i-center" v-if="inviterInf.id">
			<img :src="inviterInf.avatar_url">
			<div class="header-text flex flex-j-c-center">
				<p class="text-top">您的好友 <i>{{inviterInf.true_name || inviterInf.nickname}}</i></p>
				<p>邀请您一起来提升学历</p>
			</div>
		</div>

		<!-- v1.3 -->
		<div class="cww-home">
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_01.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_02.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_03.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_04.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_05.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_06.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_07.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_08.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_09.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_10.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_11.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_12.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_13.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_14.jpg'),loading:require('@/assets/loading.gif')}" />
			<img v-lazy="{src:require('@/assets/home/v1.3/cww_15.jpg'),loading:require('@/assets/loading.gif')}" />
		</div>
	<!--
		<div class="cww-contact" v-if="inviterInf.id">
			<span><a href="tel:4008509711"><i>电话：400-850-9711</i></a></span>
		</div>

	<div class="home-banner">
      <img src="@/assets/home/bg01@3x.png" class="banner-bg">
      <p class="banner-btn" @click="toEnrolment()">立即报名</p>
      <div class="banner-mock">
        <div class="div1">
          <div class="div2">
              <p v-for="(e, i) in mockData" :key='i'>{{e}}**报名成功</p>
          </div>
        </div>
      </div>
    </div>

    <div class="home-showImg">
      <img v-lazy="{src:require('@/assets/home/version/bg02@3x.png'),loading:require('@/assets/loading.gif')}" />
      <img v-lazy="{src:require('@/assets/home/version/text01@3x.png'),loading:require('@/assets/loading.gif')}" class="showImg11" @click="toArticle(11)"/>
      <img v-lazy="{src:require('@/assets/home/version/text02@3x.png'),loading:require('@/assets/loading.gif')}" class="showImg12" @click="toArticle(16)"/>
    </div>
    <div class="home-showImg">
      <img v-lazy="{src:require('@/assets/home/version/bg03@3x.png'),loading:require('@/assets/loading.gif')}" />
      <img v-lazy="{src:require('@/assets/home/version/text03@3x.png'),loading:require('@/assets/loading.gif')}" class="showImg13" @click="toArticle(13)"/>
      <img v-lazy="{src:require('@/assets/home/version/text04@3x.png'),loading:require('@/assets/loading.gif')}" class="showImg14" @click="toArticle(15)"/>
      <img v-lazy="{src:require('@/assets/home/version/text05@3x.png'),loading:require('@/assets/loading.gif')}" class="showImg15" @click="toArticle(17)"/>
    </div>
    <div class="home-showImg">
      <img v-lazy="{src:require('@/assets/home/version/bg04@3x.jpg'),loading:require('@/assets/loading.gif')}" />
    </div>

 -->

		<div style="height: 0.5rem;"></div>

		<div class="home-footer flex flex-a-i-center flex-j-c-center">
			<p>{{bottomTips}}</p>
			<div class="footer-btn" @click="_MEIQIA('showPanel')">点击咨询</div>
			<!-- <div class="footer-btn">点击咨询</div> -->
			<div @click="toEnrolment">我要报名</div>
		</div>

		<!-- loading -->
		<div class="isloading" v-if="isload">
			<div class="loader">
				<div class="loader-inner ball-scale">
					<div></div>
				</div>
			</div>
			<div class="loader-text">页面准备中，请稍后...</div>
		</div>

		<!-- 优惠券 -->
		<router-view />
	</div>
</template>

<script>
	import {
		getMessage,
		getCoupon,
		becomefans,
		inviterInfo,
		pageShare
	} from '@/api';
	import {
		MessageBox,
		Toast
	} from 'mint-ui';

	export default {
		name: 'HomePage',
		data() {
			return {
				isload: true, // 加载
				inviterInf: {
					avatar_url: require('@/assets/avatar.jpg'),
					// id: 1,
					nickname: "陈文卫",
				}, // 邀请人信息
				mockData: ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤',
					'许',
					'何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章',
					'云', '苏',
					'潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍',
					'史', '唐',
					'费', '廉', '岑', '薛', '雷', '贺', '倪', '汤'
				], // 模拟数据报名
				mockNum: 10667, // 模拟已报名人数
				swiperOption: {
					direction: 'vertical',
					autoplay: true,
					loop: true,
					initialSlide: 0, //初始化索引
					noSwiping: true,
					noSwipingClass: 'stop-swiping'
				}, // swiper (弃用)
				btnCoupon: false, // 按钮动画
				btnCoupons: false, // 按钮动画
				bottomTips: '' // 底部文本
			}
		},
		created() {
			// var a = {b:'c'};
			// var d = this._tools.deepClone(a);
			// d.c = 'fff'
			// console.log(d,a);

			// 数组随机处理
			this.mockData = this.mockData.sort(this._tools.randomsort);
			this.mockData = this.mockData.slice(0, 5).concat(this.mockData[0]);
			this.pageInit();
			if (sessionStorage.getItem('_shareid')) {
				this.isfans(sessionStorage.getItem('_shareid'));
				this.getInviterInfo(sessionStorage.getItem('_shareid'));
			}
		},
		mounted() {
			this.bottomTips = window._cwwConfigData ? window._cwwConfigData.bottomItem : '上大学，到陈文卫'
			let uid = JSON.parse(localStorage.getItem('cww_data')).id;
			// 线上适用
			// let sea = window.location.search ? `${window.location.search}&id=${uid}`:`${window.location.origin}?id=${uid}`;
			let sea = window.location.search ? `${window.location.search}&id=${uid}` :
				`${window.location.origin}/home?id=${uid}`;

			if (uid && this.$route.query.id && (String(this.$route.query.id) !== String(uid))) {
				sessionStorage.setItem('_shareid', String(this.$route.query.id));
				localStorage.setItem('_lastshareid', String(this.$route.query.id));
				window.location.href = `${window.location.origin}/home?id=${uid}`;
				// this.isfans();
				// this.getInviterInfo();
			} else {
				if (String(this.$route.query.id) === String(uid)) {
					if (this.$route.query.type === 'invi') {
						this.getInviterInfo(uid);
					}
				} else {
					window.location.href = sea;
				}
				this.isload = false;
			}
			this.pageCon();
		},
		methods: {
			// 页面初始化（mock数据处理）
			pageInit() {
				let mockTime = JSON.parse(localStorage.getItem('cww_retime')),
					nowData = {
						time: new Date().getTime(),
						num: 10667 + Math.floor(Math.random() * 51)
					};
				var random = Math.floor(Math.random() * 40 + 11); //Math.random()*(m-n+1)+n  11~50
				if (mockTime) {
					if ((this._tools.calculateDiffTime(Number(mockTime.time), new Date().getTime())) >= 60) {
						mockTime.num = mockTime.num + random
						mockTime.time = new Date().getTime()
						localStorage.setItem('cww_retime', JSON.stringify(mockTime));
						this.mockNum = mockTime.num;
					} else {
						this.mockNum = mockTime.num;
					}
				} else {
					localStorage.setItem('cww_retime', JSON.stringify(nowData));
					this.mockNum = nowData.num;
				}
			},
			// 分享设置
			pageCon() {
				if (localStorage.getItem('cww_data')) {
					let udata = JSON.parse(localStorage.getItem('cww_data'));
					pageShare({
						url: `${window.location.href}`
					}).then(res => {
						if (this._tools.isWechat()) {
							let params = {
								appId: res.data.appid,
								timestamp: res.data.timestamp,
								nonceStr: res.data.noncestr,
								signature: res.data.signature,
								imgUrl: `${window.location.origin}/importantImg.jpg`,
								link: `${window.location.origin}/home?id=${udata.id}&type=invi`,
								desc: `限时领取礼包 985 / 211 名校大专本科学历，社会认可、全网可查、含金量高！每月200元，轻松拿无压力拿文凭！`,
								title: '上大学，就到陈文卫！',
							}
							this._tools.wechatShareConfig(params);
						}
					})
				}
			},
			// 优惠券显示
			changeMask(e) {
				// this.showMask = true;
				this.$router.push({
					name: 'GetCoupon'
				});
				if (e === 1) {
					this.btnCoupons = true;
					setTimeout(() => {
						this.btnCoupons = false;
					}, 1000);
				} else {
					this.btnCoupon = true;
					setTimeout(() => {
						this.btnCoupon = false;
					}, 1000);
				}
			},
			// 跳转报名
			toEnrolment() {
				this.$router.push({
					path: '/Enrolment'
				})
			},
			// 成为粉丝
			isfans(id) {
				if (String(id) === String(this.$route.query.id)) {
					return false;
				}
				becomefans({
					inviter_id: id
				}).then(res => {
					// if (res.code !== 0) { Toast({message: res.msg, className: 'iconfont icon-close', duration: 2000}); }
					sessionStorage.removeItem("_shareid");
					// if (res.code == 1) {
					//   localStorage.removeItem('_lastshareid');
					// }
				})
			},
			// 邀请人信息
			getInviterInfo(id) {
				inviterInfo({
					inviter_id: id,
					require: 0
				}).then(res => {
					if (res.code === 0 && res.data.userInfo.id) {
						this.inviterInf = res.data.userInfo;
						localStorage.setItem('_lastshareUser', JSON.stringify(res.data.userInfo));
					}
					this.isload = false;
				})
			},
			// 调用客服系统
			_MEIQIA(e) {
				// window._MEIQIA(e)http://p.qiao.baidu.com/cps/chat?siteId=13703359&userId=27403334
				//window.location.href = 'http://p.qiao.baidu.com/cps/chat?siteId=13703359&userId=27403334';
				window.location.href = 'https://live.easyliao.com/live/chat.do?c=13277&g=26590&config=40265&chatUrl=成高系统';
			},
			// 跳转相关文章
			toArticle(id) {
				let uid = JSON.parse(localStorage.getItem('cww_data')).id;
				window.location.href = `${window.location.origin}/NoticeDetail?id=${id}&invitorId=${uid}`
			}
		},
		watch: {}
	};
</script>

<style lang="less" scoped>
	.homePage {
		background: #F0F0F0;

		.home-header {
			width: 100%;
			height: 0.66rem;
			background: #F0F0F0;

			img {
				width: 0.45rem;
				height: 0.45rem;
				margin-left: 0.36rem;
				border-radius: 50%;
			}

			.header-text {
				flex-direction: column;
				text-align: left;
				margin-left: 0.13rem;
				color: #333333;
				font-size: 0.16rem;

				.text-top {
					font-size: 0.12rem;

					i {
						color: #E9784A;
						font-style: normal;
					}
				}
			}

		}

		.cww-home {
			width: 100%;
			font-size: 0;
			margin: 0 auto;

			img {
				width: 100%;
				text-indent: 0;
				border: none;
				vertical-align: middle;
			}
		}

		.cww-contact {
			width: 50%;
			margin: 0 auto;
			position: fixed;
			bottom: 20%;
			right: 5px;
			background-color: #EF4F4F;

			span {
				font-size: 16px;
				color: #FFFFFF;
			}
		}

		.home-banner {
			position: relative;
			width: 100%;
			font-size: 0;

			.banner-bg {
				width: 100%;
				height: 100%;
			}

			.coupon-bg {
				position: absolute;
				top: 2.70rem;
				left: 50%;
				transform: translateX(-50%);
				width: 90%;
				height: 0.75rem;
			}

			.coupon-gift {
				width: 0.38rem;
				height: 0.40rem;
				position: absolute;
				left: 0.23rem;
				top: 50%;
				transform: translateY(-50%);
				-webkit-animation: gift 1.5s;
				animation: gift 1.5s infinite;
			}

			.coupon-click {
				width: 0.69rem;
				height: 0.59rem;
				position: absolute;
				right: 0.11rem;
				top: 50.5%;
				-webkit-transform: translateY(-50%);
				transform: translateY(-50%);
				-webkit-animation: scanthis 0.5s;
				animation: scanthis 0.5s infinite;
			}

			.banner-btn {
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				bottom: 0.38rem;
				width: 1.45rem;
				height: 0.3rem;
				background: #FFE100;
				font-size: 0.15rem;
				color: #333;
				border-radius: 3px;
				line-height: 0.3rem;
			}

			.banner-mock {
				position: absolute;
				color: white;
				font-size: 0.12rem;
				text-align: left;
				top: 0.14rem;
				left: 0.2rem;
				// right: 0.2rem;
				line-height: 0.2rem;

				img {
					width: 0.2rem;
					height: 0.2rem;
					border-radius: 50%;
				}
			}

			.swiper-container {
				height: 0.2rem;
			}
		}

		.home-footer {
			width: 100%;
			height: 0.5rem;
			background: white;
			border-top: 1px solid #EEEEEE;
			position: fixed;
			bottom: 0;
			left: 50%;
			font-size: 0.14rem;
			max-width: 640px;
			transform: translateX(-50%);

			p {
				width: 52%;

			}

			div {
				width: 24%;
				background: #F2591B;
				color: white;
				height: 0.5rem;
				line-height: 0.5rem;
			}

			.footer-btn {
				background: #F2A91B;
			}
		}
	}

	@-webkit-keyframes scanthis {
		0% {
			-webkit-transform: scale(1) translateY(-50%);
			transform: scale(1) translateY(-50%);
		}

		80% {
			-webkit-transform: scale(1.02) translateY(-50%);
			transform: scale(1.02) translateY(-50%);
		}
	}

	@keyframes scanthis {
		0% {
			-webkit-transform: scale(1) translateY(-50%);
			transform: scale(1) translateY(-50%);
		}

		80% {
			-webkit-transform: scale(1.02) translateY(-50%);
			transform: scale(1.02) translateY(-50%);
		}
	}

	@-webkit-keyframes gift {

		0%,
		20%,
		40%,
		60% {
			-webkit-transform: rotate(8deg) translateY(-50%);
			transform: rotate(8deg) translateY(-50%);
		}

		10%,
		30%,
		50% {
			-webkit-transform: rotate(-8deg) translateY(-50%);
			transform: rotate(-8deg) translateY(-50%);
		}

		70%,
		100% {
			-webkit-transform: rotate(0deg) translateY(-50%);
			transform: rotate(0deg) translateY(-50%);
		}
	}

	@keyframes gift {

		0%,
		20%,
		40%,
		60% {
			-webkit-transform: rotate(8deg) translateY(-50%);
			transform: rotate(8deg) translateY(-50%);
		}

		10%,
		30%,
		50% {
			-webkit-transform: rotate(-8deg) translateY(-50%);
			transform: rotate(-8deg) translateY(-50%);
		}

		70%,
		100% {
			-webkit-transform: rotate(0deg) translateY(-50%);
			transform: rotate(0deg) translateY(-50%);
		}
	}

	.isloading {
		z-index: 999;
		width: 100%;
		height: 100vh;
		background: white;
		position: fixed;
		top: 0;
		left: 0;
	}

	.div1 {
		// width:200px;
		height: 0.2rem;
		overflow: hidden;
	}

	@keyframes aaa {
		0% {
			transform: translatey(0px);
		}

		15% {
			transform: translatey(-0.2rem);
		}

		25% {
			transform: translatey(-0.2rem);
		}

		35% {
			transform: translateY(-0.4rem);
		}

		45% {
			transform: translatey(-0.4rem);
		}

		55% {
			transform: translateY(-0.6rem);
		}

		65% {
			transform: translatey(-0.6rem);
		}

		75% {
			transform: translateY(-0.8rem);
		}

		85% {
			transform: translatey(-0.8rem);
		}

		95% {
			transform: translateY(-1rem);
		}

		100% {
			transform: translatey(-1rem);
		}
	}

	.div2 {
		animation: aaa 12s infinite linear normal;
	}

	.home-showImg {
		width: 100%;
		font-size: 0;
		position: relative;

		img {
			width: 100%;
		}

		&>div {
			position: absolute;
		}
	}

	.showImg11,
	.showImg12,
	.showImg13,
	.showImg14,
	.showImg15 {
		width: 100% !important;
		// height: 2.47rem;
		position: absolute;
		// top: 0.12rem;
		left: 50%;
		transform: translateX(-50%);
	}

	// .showImg12{
	//   height: 2.15rem;
	//   top: 2.87rem;
	// }
	// .showImg13{
	//   height: 1.29rem;
	//   top: 0.13rem;
	// }
	// .showImg14{
	//   height: 0.95rem;
	//   top: 1.45rem;
	// }
	// .showImg15{
	//   height: 2.8rem;
	//   top: 2.65rem;
	// }
</style>
